export const DATA_API_CONSTANT = {


  // Authentication
LOGIN:'api/auth/login',
ADMIN_LOGIN:'api/auth/admin_login',











//webapp

UPLOAD_PAYSHEET:'api/webapp/upload_paysheet',
GET_EMPLOYEE_LIST:'api/webapp/get_employee_list',
UPLOADED_DATES:'api/webapp/get_paysheet_uploaded_files',
GET_PAYSHEET_DATA:"api/webapp/get_uploaded_sheet/" ,
UPDATE_EMPLOYEE_DETAILS:"api/webapp/update_employee_details",
UPDATE_PAYSHEET:"api/webapp/update_paysheet",
SEND_OTP:"api/webapp/sendotp",
FORGOT_PASSWORD:"api/webapp/forgot_password",
AUDIT_LOGS:"api/webapp/get_audit_logs",
DELETE_PAYSHEET:"api/webapp/delete_paysheet",
GET_FEATURES:"api/webapp/get_features",
UPDATE_FEATURE_STATUS:"api/webapp/update_feature_status",

USER_UPLOAD_PAYSHEET:'api/webapp/bulk_upload_sheet',
GET_USERSHEET_FILES:'api/webapp/get_user_sheets',
REMOVE_USERSHEET:'api/webapp/delete_usersheet',
GET_USERSHEET_DETAILS:'api/webapp/get_sheet_details',
UPDATE_USER_SHEET_DATA:'api/webapp/update_usersheet_data'
};
